module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/belluno.e10cf5eac869aff3367b7fdf42b134fc.jpg";